module.exports = "/_next/static/images/game-1-intro-tutorial-paper-3140387450e122dc4c4b51bf9661dc0e.png";